module.exports = __webpack_public_path__ + "img/cloud_L.8578f8c4.png";